"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VelvetAuthorizationManager = exports.CustomTokenError = exports.LoginCodeError = exports.ApiTokenError = exports.ResendVerificationCodeError = exports.ConfirmVerificationCodeError = exports.LoginError = exports.RegistrationError = void 0;
var tslib_1 = require("tslib");
var constants_1 = require("../../../../constants/constants");
var sdk_1 = require("../../../../sdk/sdk");
var RegistrationError = /** @class */ (function (_super) {
    tslib_1.__extends(RegistrationError, _super);
    function RegistrationError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, RegistrationError.prototype);
        return _this;
    }
    return RegistrationError;
}(Error));
exports.RegistrationError = RegistrationError;
var LoginError = /** @class */ (function (_super) {
    tslib_1.__extends(LoginError, _super);
    function LoginError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, LoginError.prototype);
        return _this;
    }
    return LoginError;
}(Error));
exports.LoginError = LoginError;
var ConfirmVerificationCodeError = /** @class */ (function (_super) {
    tslib_1.__extends(ConfirmVerificationCodeError, _super);
    function ConfirmVerificationCodeError() {
        var _this = _super.call(this) || this;
        Object.setPrototypeOf(_this, ConfirmVerificationCodeError.prototype);
        return _this;
    }
    return ConfirmVerificationCodeError;
}(Error));
exports.ConfirmVerificationCodeError = ConfirmVerificationCodeError;
var ResendVerificationCodeError = /** @class */ (function (_super) {
    tslib_1.__extends(ResendVerificationCodeError, _super);
    function ResendVerificationCodeError() {
        var _this = _super.call(this) || this;
        Object.setPrototypeOf(_this, ResendVerificationCodeError.prototype);
        return _this;
    }
    return ResendVerificationCodeError;
}(Error));
exports.ResendVerificationCodeError = ResendVerificationCodeError;
var ApiTokenError = /** @class */ (function (_super) {
    tslib_1.__extends(ApiTokenError, _super);
    function ApiTokenError() {
        var _this = _super.call(this) || this;
        Object.setPrototypeOf(_this, ApiTokenError.prototype);
        return _this;
    }
    return ApiTokenError;
}(Error));
exports.ApiTokenError = ApiTokenError;
var LoginCodeError = /** @class */ (function (_super) {
    tslib_1.__extends(LoginCodeError, _super);
    function LoginCodeError() {
        var _this = _super.call(this) || this;
        Object.setPrototypeOf(_this, LoginCodeError.prototype);
        return _this;
    }
    return LoginCodeError;
}(Error));
exports.LoginCodeError = LoginCodeError;
var CustomTokenError = /** @class */ (function (_super) {
    tslib_1.__extends(CustomTokenError, _super);
    function CustomTokenError() {
        var _this = _super.call(this) || this;
        Object.setPrototypeOf(_this, CustomTokenError.prototype);
        return _this;
    }
    return CustomTokenError;
}(Error));
exports.CustomTokenError = CustomTokenError;
/**
 * @class
 * @remarks This class provides the implementation for Velvet authentication management operations.
 */
var VelvetAuthorizationManager = /** @class */ (function () {
    function VelvetAuthorizationManager(networkService, tokenManager) {
        var config = sdk_1.VelvetSDK.Configuration.configuration;
        if (!(config === null || config === void 0 ? void 0 : config.apiEndpointBaseUrl) || !(config === null || config === void 0 ? void 0 : config.apiEndpoints)) {
            throw new Error('Invalid SDK configuration');
        }
        this.config = config;
        this.baseUrl = config.apiEndpointBaseUrl;
        this.networkService = networkService;
        this.tokenManager = tokenManager;
    }
    VelvetAuthorizationManager.prototype.register = function (uid, subscription) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var accessToken, registerUrl, fullRegisterUrl, requestable, response, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        accessToken = localStorage.getItem(constants_1.authAccessTokenLS);
                        if (!accessToken) {
                            throw new RegistrationError('No access token found.');
                        }
                        registerUrl = this.config.apiEndpoints.register;
                        fullRegisterUrl = registerUrl.replace(constants_1.CMS.BASE_URL, this.baseUrl);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        requestable = {
                            url: fullRegisterUrl,
                            method: constants_1.HTTP_METHOD.POST,
                            body: { accessToken: accessToken, uid: uid, subscription: subscription },
                        };
                        return [4 /*yield*/, this.networkService.fetch(requestable)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Error during registration: ".concat(error_1));
                        throw new RegistrationError("Registration failed: ".concat(error_1.message || error_1));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VelvetAuthorizationManager.prototype.login = function (uid) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var accessToken, loginUrl, fullLoginUrl, requestable, response, activeTokens, error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        accessToken = localStorage.getItem(constants_1.authAccessTokenLS);
                        if (!accessToken) {
                            throw new LoginError('No access token found.');
                        }
                        loginUrl = this.config.apiEndpoints.login;
                        fullLoginUrl = loginUrl.replace(constants_1.CMS.BASE_URL, this.baseUrl);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        requestable = {
                            url: fullLoginUrl,
                            method: constants_1.HTTP_METHOD.POST,
                            body: { accessToken: accessToken, uid: uid },
                        };
                        return [4 /*yield*/, this.networkService.fetch(requestable)];
                    case 2:
                        response = _a.sent();
                        activeTokens = {
                            accessToken: response === null || response === void 0 ? void 0 : response.token,
                            accessRefreshToken: response === null || response === void 0 ? void 0 : response.refreshToken,
                        };
                        this.tokenManager.saveTokens(activeTokens);
                        return [2 /*return*/, response];
                    case 3:
                        error_2 = _a.sent();
                        console.error("Error during login: ".concat(error_2));
                        throw new LoginError("Login failed: ".concat(error_2.message || error_2));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // TODO: After testing, found that the token is not being passed. Recheck token handling and the commented profile creation logic when implementing on web.
    VelvetAuthorizationManager.prototype.confirmVerificationCode = function (verificationCode) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var verificationConfirmUrl, fullVerificationConfirmUrl, requestable, response, error_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        verificationConfirmUrl = this.config.apiEndpoints.verificationConfirm;
                        fullVerificationConfirmUrl = verificationConfirmUrl.replace(constants_1.CMS.BASE_URL, this.baseUrl);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        requestable = {
                            url: fullVerificationConfirmUrl,
                            method: constants_1.HTTP_METHOD.POST,
                            body: { code: verificationCode },
                            // headers: parsedUser?.token ? { Authorization: `Bearer ${parsedUser.token}` } : {},
                        };
                        return [4 /*yield*/, this.networkService.fetch(requestable)
                            // const profilesManager = VelvetSDK.Storage.Profiles.service
                            // const userHasProfiles = await profilesManager.userHasProfiles(parsedUser.userID)
                            // const image = VelvetSDK.Configuration.configuration.profileImages[0].data[0]
                            // if (!userHasProfiles) {
                            //   await profilesManager.createProfile({
                            //     name: '',
                            //     image: image,
                            //   })
                            // }
                        ];
                    case 2:
                        response = _a.sent();
                        // const profilesManager = VelvetSDK.Storage.Profiles.service
                        // const userHasProfiles = await profilesManager.userHasProfiles(parsedUser.userID)
                        // const image = VelvetSDK.Configuration.configuration.profileImages[0].data[0]
                        // if (!userHasProfiles) {
                        //   await profilesManager.createProfile({
                        //     name: '',
                        //     image: image,
                        //   })
                        // }
                        return [2 /*return*/, response];
                    case 3:
                        error_3 = _a.sent();
                        console.error(error_3);
                        throw new ConfirmVerificationCodeError();
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VelvetAuthorizationManager.prototype.resendVerificationCode = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var verificationSendUrl, fullVerificationSendUrl, requestable, response, error_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        verificationSendUrl = this.config.apiEndpoints.verificationSend;
                        fullVerificationSendUrl = verificationSendUrl.replace(constants_1.CMS.BASE_URL, this.baseUrl);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        requestable = {
                            url: fullVerificationSendUrl,
                            method: constants_1.HTTP_METHOD.POST,
                        };
                        return [4 /*yield*/, this.networkService.fetch(requestable)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 3:
                        error_4 = _a.sent();
                        console.error(error_4);
                        throw new ResendVerificationCodeError();
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VelvetAuthorizationManager.prototype.getUser = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var checkTokenUrl, fullCheckTokenUrl, userTokens, accessToken, requestable, response, error_5;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        checkTokenUrl = this.config.apiEndpoints.checkToken;
                        fullCheckTokenUrl = checkTokenUrl.replace(constants_1.CMS.BASE_URL, this.baseUrl);
                        userTokens = this.tokenManager.getTokens();
                        accessToken = userTokens === null || userTokens === void 0 ? void 0 : userTokens.accessToken;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        requestable = {
                            url: fullCheckTokenUrl,
                            method: constants_1.HTTP_METHOD.GET,
                            headers: { Authorization: "Bearer ".concat(accessToken) },
                        };
                        return [4 /*yield*/, this.networkService.fetch(requestable)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 3:
                        error_5 = _a.sent();
                        throw new ApiTokenError();
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VelvetAuthorizationManager.prototype.fetchPinPairCode = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var pinPairCodeUrl, fullPinPairCodeUrl, requestable, response, error_6;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pinPairCodeUrl = this.config.apiEndpoints.pinPairCode;
                        fullPinPairCodeUrl = pinPairCodeUrl.replace(constants_1.CMS.BASE_URL, this.baseUrl);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        requestable = {
                            url: fullPinPairCodeUrl,
                            method: constants_1.HTTP_METHOD.GET,
                        };
                        return [4 /*yield*/, this.networkService.fetch(requestable)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 3:
                        error_6 = _a.sent();
                        throw new LoginCodeError();
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VelvetAuthorizationManager.prototype.fetchPinPairToken = function (code) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var pinPairTokenUrl, pinPairTokenEndpoint, requestUrl, requestable, response, error_7;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pinPairTokenUrl = this.config.apiEndpoints.pinPairToken;
                        pinPairTokenEndpoint = pinPairTokenUrl.replace(constants_1.CMS.BASE_URL, this.baseUrl);
                        requestUrl = "".concat(pinPairTokenEndpoint, "?code=").concat(code);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        requestable = {
                            url: requestUrl,
                            method: constants_1.HTTP_METHOD.GET,
                        };
                        return [4 /*yield*/, this.networkService.fetch(requestable)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 3:
                        error_7 = _a.sent();
                        throw new CustomTokenError();
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return VelvetAuthorizationManager;
}());
exports.VelvetAuthorizationManager = VelvetAuthorizationManager;
